import { NavLink } from "react-router-dom";
import { useState } from "react";
import {
  FaBuilding,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaClock,
  FaHeart
} from "react-icons/fa";
import { submitToGoogleSheets, isValidEmail } from "../utils/googleSheets";

const Footer = () => {
  const [newsletter, setNewsletter] = useState({
    email: "",
  });
  const [newsletterLoading, setNewsletterLoading] = useState(false);
  const [newsletterFeedback, setNewsletterFeedback] = useState({ type: "", message: "" });

  const handleNewsletterChange = (e) => {
    const { value } = e.target;
    setNewsletter({ email: value });
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setNewsletterLoading(true);
    setNewsletterFeedback({ type: "", message: "" });

    if (!newsletter.email || !isValidEmail(newsletter.email)) {
      setNewsletterFeedback({
        type: "error",
        message: "Please enter a valid email address",
      });
      setNewsletterLoading(false);
      return;
    }

    try {
      await submitToGoogleSheets(
        {
          email: newsletter.email,
        },
        "newsletter"
      );

      setNewsletterFeedback({
        type: "success",
        message: "Subscribed successfully! Check your email.",
      });

      setNewsletter({ email: "" });

      setTimeout(() => {
        setNewsletterFeedback({ type: "", message: "" });
      }, 3000);
    } catch (error) {
      console.error("Newsletter subscription error:", error);
      setNewsletterFeedback({
        type: "error",
        message: "Error subscribing. Please try again.",
      });
    } finally {
      setNewsletterLoading(false);
    }
  };
  return (
    <footer className="bg-slate-100 border-t">

      {/* TOP FOOTER */}
      <div className="max-w-7xl mx-auto px-4 lg:px-8 pt-16 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

          {/* BRAND */}
          <div>
            <div className="flex items-center gap-2 mb-5">
              <FaBuilding className="text-primary text-xl" />
              <h4 className="font-bold text-lg text-slate-900">
                Ramesh Property
              </h4>
            </div>

            <p className="text-sm text-slate-600 leading-relaxed mb-6">
              Aduri Group delivers premium plotted developments and real estate
              investments with transparency, trust, and long-term value.
            </p>

            {/* SOCIAL LINKS */}
            <div className="flex gap-4 text-slate-500">
              <a href="https://www.facebook.com/adurigroup" target="_blank" rel="noreferrer">
                <FaFacebookF className="hover:text-primary cursor-pointer" />
              </a>
              <a href="https://twitter.com/adurigroup" target="_blank" rel="noreferrer">
                <FaTwitter className="hover:text-primary cursor-pointer" />
              </a>
              <a href="https://www.instagram.com/adurigroupofficial" target="_blank" rel="noreferrer">
                <FaInstagram className="hover:text-primary cursor-pointer" />
              </a>
              <a href="https://www.linkedin.com/company/aduri-group" target="_blank" rel="noreferrer">
                <FaLinkedinIn className="hover:text-primary cursor-pointer" />
              </a>
            </div>
          </div>

          {/* QUICK LINKS (MATCH NAVBAR) */}
          <div>
            <h4 className="font-bold text-slate-900 mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><NavLink to="/" className="hover:text-primary">Home</NavLink></li>
              <li><NavLink to="/#premium-projects" className="hover:text-primary">Projects</NavLink></li>
              <li><NavLink to="/aboutus" className="hover:text-primary">About Us</NavLink></li>
              <li><NavLink to="/faqs" className="hover:text-primary">FAQs</NavLink></li>
              <li><NavLink to="/contact" className="hover:text-primary">Contact</NavLink></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h4 className="font-bold text-slate-900 mb-5">Contact Us</h4>

            <ul className="space-y-4 text-sm text-slate-600">
              <li className="flex gap-3">
                <FaMapMarkerAlt className="text-primary mt-1" />
                <span>
                  3rd Floor, Plot No. 14, Lodha Road,
                  <br />
                  5th Phase, KPHB, Hyderabad – 72
                </span>
              </li>

              <li className="flex items-center gap-3">
                <FaPhoneAlt className="text-primary" />
                <span>+91 83742 49705</span>
              </li>

              <li className="flex items-center gap-3">
                <FaWhatsapp className="text-primary" />
                <span>+91 83319 05506</span>
              </li>

              <li className="flex items-center gap-3">
                <FaEnvelope className="text-primary" />
                <span>rameshgadhamv6@gmail.com</span>
              </li>

              <li className="flex items-center gap-3">
                <FaClock className="text-primary" />
                <span>Mon – Sat: 8:00 AM – 6:00 PM</span>
              </li>
            </ul>
          </div>

          {/* NEWSLETTER */}
          <div>
            <h4 className="font-bold text-slate-900 mb-5">
              Subscribe to Newsletter
            </h4>

            <p className="text-sm text-slate-600 mb-4">
              Get updates on new launches and investment opportunities.
            </p>

            {newsletterFeedback.message && (
              <div
                className={`mb-3 p-2 rounded-md text-xs font-medium ${
                  newsletterFeedback.type === "success"
                    ? "bg-green-100 text-green-800 border border-green-300"
                    : "bg-red-100 text-red-800 border border-red-300"
                }`}
              >
                {newsletterFeedback.message}
              </div>
            )}

            <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-2">
              <input
                type="email"
                value={newsletter.email}
                onChange={handleNewsletterChange}
                placeholder="Your Email Address"
                className="w-full px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary"
              />

              <button 
                type="submit"
                disabled={newsletterLoading}
                className="w-full bg-primary hover:bg-primaryDark text-white py-2 rounded-md font-medium transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {newsletterLoading ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="border-t">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <div className="text-center md:text-left space-y-1">
            <p className="text-gray-400 text-sm flex items-center gap-2">
                © 2025 <span className="text-primary font-semibold">Ramesh Property.</span>All rights reserved.
                <span className="text-gray-600">|</span>
                <span className="text-gray-500 flex items-center gap-1">
                  Made with <FaHeart className="w-3 h-3 text-red-400" /> by Amplinovians
                </span>
              </p>
          </div>

          <div className="flex gap-6">
            <span className="hover:text-primary cursor-pointer">Privacy Policy</span>
            <span className="hover:text-primary cursor-pointer">Terms & Conditions</span>
            <span className="hover:text-primary cursor-pointer">Disclaimer</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
